import { render, staticRenderFns } from "./OverviewCard.vue?vue&type=template&id=38259a3a&scoped=true&"
import script from "./OverviewCard.vue?vue&type=script&lang=ts&setup=true&"
export * from "./OverviewCard.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./OverviewCard.vue?vue&type=style&index=0&id=38259a3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38259a3a",
  null
  
)

export default component.exports